import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class GuidService {

	public readonly emptyGUID: string = '00000000-0000-0000-0000-000000000000';

	constructor() { }

	generateGUID(): string {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0,
				v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}

	GUIDisEmpty(guid: string) {
		return guid === this.emptyGUID;
	}

}

